import { z } from 'zod';

import { InstanceIdType } from '#core/schema/defs';
import { CogniteAssetModel } from '#core/schema/model/cdm/CogniteAssetModel';

import { WellModel } from '#schema/model/WellModel';

export const WellStringModel = z
  .object({
    ...CogniteAssetModel.shape,

    parent: WellModel.or(InstanceIdType).optional(),

    fullName: z.string().optional().describe('Full name of the well string.'),
    wellboreGeometry: InstanceIdType.optional().describe('Reference to wellbore geometry data for this well string.'),
    scaleInterval: InstanceIdType.optional().describe('Reference to ScaleInterval data for this well string.'),
    wellStringInterval: InstanceIdType.optional().describe(
      'Reference to WellStringInterval data for this well string.',
    ),
    completion: InstanceIdType.array().optional().describe('References to Completion assets for this well string.'),
    scaleDiscovery: InstanceIdType.array()
      .optional()
      .describe('References to ScaleDiscovery assets for this well string.'),
    scaleIntervention: InstanceIdType.array()
      .optional()
      .describe('References to ScaleIntervention assets for this well string.'),
  })
  .describe('Well string asset, representing a single well string.');

export type WellStringModelInput = z.input<typeof WellStringModel>;
export type WellStringModelOutput = z.output<typeof WellStringModel>;
